import { render, staticRenderFns } from "./OutboundDetailsPopup.vue?vue&type=template&id=37dc3824&scoped=true&"
import script from "./OutboundDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./OutboundDetailsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dc3824",
  null
  
)

export default component.exports